export default {"src":"/bnb/_next/static/media/near.52f5ca81.svg","height":10,"width":10};